module.exports = __webpack_public_path__ + "static/media/niao.ca7bed5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/niao.mp3
// module id = g/jM
// module chunks = 9